module.exports = __webpack_public_path__ + "img/zw.fee95500.svg";